var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h900v600H0z",
    fill: "#ce1126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h600v600H0z",
    fill: "#fcd116"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h300v600H0z",
    fill: "#14b53a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMl);
export default __webpack_public_path__ + "static/media/ml.766ed557076a31a8d962caacd06821ad.svg";
export { ForwardRef as ReactComponent };